import { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import ERegitrationRoutePage from 'src/modules/Auth/ERegistration/ERegitrationRoutePage'
import ForgotRoutePage from 'src/modules/Auth/ForgotPassword/ForgotRoutePage'
import NewRegistrationMain from 'src/modules/Auth/NewRegistration/NewRegistrationMain'
import LoginsRoutes from 'src/Pages/LoginPage/LoginsRoutes'
import OnboardingRoutes from 'src/Pages/OnboardingPage/OnboardingRoutes'




const AuthRoutes = () => {

    return (
        <Routes>
            <Route path="login/*" element={<LoginsRoutes />} />
            {/* <Route path="register/*" element={<ERegitrationRoutePage />} /> */}
            {/* <Route path="register/*" element={<NewRegistrationMain />} /> */}
            <Route path='forgot-password/*' element={<ForgotRoutePage />} />
            <Route path='onboarding/*' element={<OnboardingRoutes />} />
            <Route index element={<LoginsRoutes />} />
        </Routes>
    )
}

export default AuthRoutes

